var map = {
	"./shrimp1.png": 9762,
	"./shrimp10.png": 6964,
	"./shrimp11.png": 8033,
	"./shrimp12.png": 5085,
	"./shrimp13.png": 8275,
	"./shrimp14.png": 8898,
	"./shrimp15.png": 8941,
	"./shrimp16.png": 8132,
	"./shrimp17.png": 383,
	"./shrimp18.png": 4968,
	"./shrimp19.png": 6920,
	"./shrimp2.png": 5627,
	"./shrimp20.png": 3714,
	"./shrimp21.png": 8522,
	"./shrimp3.png": 2782,
	"./shrimp4.png": 4020,
	"./shrimp5.png": 3479,
	"./shrimp6.png": 693,
	"./shrimp7.png": 5273,
	"./shrimp8.png": 4145,
	"./shrimp9.png": 8902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5692;